<template>
  <div class="w-full h-full flex-column a-center j-center">
    <div class="" id="weixinLogin" style="width: 200px;height: 200px">
    </div>
  </div>
</template>

<script>
import {loadJs} from '../../../utils/loadJs'

export default {
  name: 'TestLogin',
  data () {
    return {
      wxObj: null,
      wxstatus: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      loadJs('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js').then(() => {
        this.wxstatus = parseInt(new Date().getTime() / 1000)
        this.wxObj = new WxLogin({
          self_redirect: false,
          id: 'weixinLogin',
          appid: 'wxc43e2f5ff7fe1f79',
          scope: 'snsapi_login',
          redirect_uri: 'https://www.cfc99.com/personcenter',
          state: this.wxstatus,
          style: 'black',
          href: 'https://image-p.laodao.so/css/qrcode.css'
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
